import { styled } from '@mui/material/styles';

export const WidgetHeader = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    ...theme.typography.body2,
    padding: theme.spacing(1),
    borderRadius: '4px 4px 0 0',
    color: "white",
}));
